module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/demo/read-me/read-me.component.sass
// module id = ./src/app/demo/read-me/read-me.component.sass
// module chunks = main